export default {"src":"/_next/static/media/nodejs_logo_4703833cf2.080c86d5.svg","height":160,"width":320,"blurWidth":0,"blurHeight":0};